import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {isNullOrUndefined} from 'util';
import initDataTable = require('../../../assets/js/init/initDataTable');
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, AfterViewInit {
  @Input() title: string;
  @Input() data;
  @Input() columns;
  @Input() entity;
  @Input() actions;
  @Input() actionColumns;
  @Input() hasDataTables;
  @Input() states;
  @Input() prevPath;
  @Input() searchBar = true;
  @Input() typeUsers = false;
  @Input() activation = false;
  @Input() loading;
  @Output() onDelete = new EventEmitter<string>();
  @Output() onSetLimit = new EventEmitter<string>();
  @Output() onSetQuery = new EventEmitter<string>();
  @Output() onFilterTypeUsers = new EventEmitter<any>();
  @Output() onSetOffset = new EventEmitter<string>();
  @Output() onSetOrder = new EventEmitter<string>();
  @Output() onCustomAction = new EventEmitter<string>();
  @Output() onUnCustomAction = new EventEmitter<string>();
  @Output() onSetState = new EventEmitter<any>();
  @Output() onFilterStates = new EventEmitter<any>();
  @Output() onActivateItems = new EventEmitter<any>();
  @Output() onFilterActives = new EventEmitter<any>();
  @Output() onFilterByDeliveredStatus = new EventEmitter<any>();
  @Output() onFilterByPaymentStatus = new EventEmitter<any>();
  @Output() onFilterByDateFrom = new EventEmitter<any>();
  @Output() onFilterByDateTo = new EventEmitter<any>();

  private searchTerms = new Subject<string>();

  Arr = Array;
  pagePosition = 0;
  active = '';
  order = '';
  // itemPos is used to sorting icons
  itemPos = -1;

  bulkSelected = false;

  selectedList = [];

  constructor() {
  }

  ngOnInit() {
    this.searchTerms
      .debounceTime(800)        // wait 800ms after each keystroke before considering the term
      .distinctUntilChanged()   // ignore if next search term is same as previous
      .map((term) => term)
      .subscribe((term) => {
        this.onSetQuery.emit(term);
      });
  }

  ngAfterViewInit() {
    if (this.hasDataTables) {
      initDataTable('datatables', this.hasDataTables); // TODO: refactor this.hasDataTables to isServerSide if datatable loads from server
    }
  }

  getObjects() {
    return this.data.objects;
  }

  getLength() {
    return this.data.length;
  }

  getMin() {
    return this.data.offset + 1;
  }

  getMax() {
    return Math.min(this.getMin() + this.getLimit() - 1, this.getLength());
  }

  getLimit() {
    return this.data.pagination;
  }

  keys(dict) {
    return Object.keys(dict);
  }

  isHighlighted(elem) {
    return (!(elem.highlightDate === undefined || elem.highlightDate === isNullOrUndefined));
  }

  isUndefined(val) {
    return (val === 'undefined' || val === isNullOrUndefined);
  }

  delete(id) {
    if (confirm('Seguro desea BORRAR el elemento?')) {
      this.onDelete.emit(id);
    }
  }

  customAction(id) {
    this.onCustomAction.emit(id);
  }

  unCustomAction(id) {
    this.onUnCustomAction.emit(id);
  }

  isActive(value) {
    return (this.pagePosition === +value) ? 'active' : '';
  }

  isBookData() {
    return this.entity === 'book';
  }

  setLimit(value) {
    this.data.pagination = +value;
    this.onSetLimit.emit(value);
    this.getPages();
  }

  search(evt): void {
    if (evt.code === 'Enter') {
      this.searchTerms.next(evt.target.value);
    }
  }

  setOffset(value) {
    this.pagePosition = +value;
    const offsetValue = +value * +this.data.pagination;
    this.onSetOffset.emit(offsetValue.toString());
  }

  setOrder(value, itemPos) {
    this.setOrderIcon(itemPos);
    this.onSetOrder.emit(value);
  }

  getPages() {
    const a = (this.getLimit() > 0) ? Math.floor(this.getLength() / this.getLimit() + 1) : 1;
    return a;
  }

  getFirstPage() {
    if (this.pagePosition > 0) {
      this.pagePosition = 0;
      const offsetValue = 0;
      this.onSetOffset.emit(offsetValue.toString());
    }
  }

  getPrevPage() {
    if (this.pagePosition > 0) {
      this.pagePosition -= 1;
      const offsetValue = this.pagePosition * +this.data.pagination;
      this.onSetOffset.emit(offsetValue.toString());
    }
  }

  getNextPage() {
    if (this.pagePosition + 1 < this.getPages()) {
      this.pagePosition += 1;
      const offsetValue = this.pagePosition * +this.data.pagination;
      this.onSetOffset.emit(offsetValue.toString());
    }
  }

  getLastPage() {
    if (this.pagePosition + 1 !== this.getPages()) {
      this.pagePosition = this.getPages() - 1;
      const offsetValue = this.pagePosition * +this.data.pagination;
      this.onSetOffset.emit(offsetValue.toString());
    }
  }

  sortIcon(item) {
    let cls = 'sorting fa fa-sort';
    if (item === this.itemPos) {
      cls = (this.order === 'asc') ? 'sorting fa fa-sort-asc' : 'sorting fa fa-sort-desc';
    }
    return cls;
  }

  setOrderIcon(itemPos) {
    if (itemPos !== this.itemPos) {
      this.order = '';
      this.itemPos = itemPos;
    }
    if (this.order === '') {
      this.order = 'asc';
    } else {
      this.order = (this.order === 'asc') ? 'desc' : 'asc';
    }
  }

  // set reservation state ['pendiente','entregado',...]
  setState(id, value) {
    this.onSetState.emit([id, value]);
  }

  filterStates(value) {
    this.onFilterStates.emit(value);
  }

  filterTypeUsers(value) {
    this.onFilterTypeUsers.emit(value);
  }

  filterActives(value) {
    this.onFilterActives.emit(value);
  }

  filterByDeliveredStatus(value) {
    this.onFilterByDeliveredStatus.emit(value);
  }

  filterByPaymentStatus(value) {
    this.onFilterByPaymentStatus.emit(value);
  }

  filterByDateFrom(value) {
    this.onFilterByDateFrom.emit(value);
  };

  filterByDateTo(value) {
    this.onFilterByDateTo.emit(value);
  };

  getColumnLength() {
    let colLength = (this.columns) ? this.columns.length : 0;
    let actionLength = (this.actions) ? 1 : 0;
    return colLength + actionLength;
  }

  // select or unselect all visible rows
  toggleSelection() {
    if (this.selectedList.length > 0) {
      this.selectedList = [];
    } else {
      this.selectedList = [];
      for (let item of this.data.objects) {
        this.selectedList.push(item.id);
      }
    }
  }

  toggleList(id) {
    let pos = this.selectedList.indexOf(id);
    if (pos !== -1) {
      this.selectedList.splice(pos, 1);
    } else {
      this.selectedList.push(id);
    }
  }

  //return true if element is in selectedList
  isChecked(id) {
    return this.selectedList.indexOf(id) !== -1;
  }

  //emit selected list to hit endpoint
  activateItems() {
    this.onActivateItems.emit(this.selectedList);
    this.selectedList = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/table/table.component.ts